import FileSaver from "file-saver";
import moment from "moment";
import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { downloadCheckInsReportsApi } from "../../../apis/mySpaceApis";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import { GetAllMasterDataBranchPayloadType } from "../../../commonTypes/masterDataTypes";
import {
  GetCheckInScheduleListPayloadType,
  GetSingleCheckInScheduleDetailsPayloadType,
} from "../../../commonTypes/mySpaceType";
import CheckInScheduleTable from "../../../components/MySpace/CheckInModule/CheckInScheduleTable";
import CheckInsFilter from "../../../components/MySpace/CheckInModule/CheckInsFilter";
import DownloadCheckInReports from "../../../components/MySpace/CheckInModule/DownloadCheckInReports";
import ViewUsersDetails from "../../../components/MySpace/CheckInModule/ViewUsersDetails";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import InfiniteLoader from "../../../components/commons/InfiniteLoader/InfiniteLoader";
import { CHECK_IN_SCHEDULE_HEADERS } from "../../../constant/tableHeadersConstants/checkInScheduleListHeader";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import useDebounce from "../../../customHooks/useDebounce";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import {
  getAllFinacManagerAction,
  getAllFinacUsersAction,
  resetFinacManagerList,
  resetFinacUsersList,
  resetSession,
} from "../../../redux/auth";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import {
  getAllMasterDataBranchAction,
  resetMasterDataLisitng,
} from "../../../redux/masterData";
import {
  getCheckInScheduleListAction,
  getSingleCheckInScheduleDetailsAction,
  resetCheckInScheduleList,
  resetMySpaceError,
  resetMySpaceMessage,
  resetMySpaceSuccess,
  resetSingleCheckInScheduleDetails,
} from "../../../redux/mySpace";
import { GetCheckInDetailDataType } from "../../../redux/mySpace/mySpaceTypes";
import { RootState } from "../../../redux/rootReducers";
import { getCurrentMonthDates } from "../../../utils/commonFunctions";

type AppProps = {
  token: string | null;
  history: any;
  fetching: boolean;
  success: number | null;
  error: string | null;
  message: string | null;
  statusCode: number | null;
  checkInScheduleList: GetCheckInDetailDataType[] | [];
  loginData: LoginResponseType;
  dispatchResetSession: () => void;
  dispatchResetCheckInScheduleList: () => void;
  checkInScheduleTotalCount: number;
  dispatchGetCheckInScheduleList: (
    data: GetCheckInScheduleListPayloadType
  ) => void;
  userFetching: boolean;
  singleCheckInScheduleFetching: boolean;
  singleCheckInScheduleDetails: GetCheckInDetailDataType;
  totalUserCount: number | string | any;
  finacUsersList: any;
  finacManagerList: any;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchResetFinacUsersList: () => void;
  dispatchResetFinacManagerList: () => void;
  dispatchResetMySpaceSuccess: () => void;
  dispatchResetMySpaceMessage: () => void;
  dispatchResetMySpaceError: () => void;
  dispatchGetSingleCheckInScheduleDetailsAction: (
    data: GetSingleCheckInScheduleDetailsPayloadType
  ) => void;
  dispatchResetSingleCheckInScheduleDetails: () => void;
  dispatchResetMasterDataListing: () => void;
  dispatchGetMasterDataBranch: (
    data: GetAllMasterDataBranchPayloadType
  ) => void;
  masterDataListing: [];
  masterDataBranchListTotal: string | number;
  totalManagerCount: string | number;
};

export type DropDownItemType = {
  value: number | null | undefined;
  label: string;
};

export type ClientListType = {
  value: number | null;
  label: string | null;
};

export type FilterTextType = {
  userText: string;
  managerText: string;
  branchText: string;
};

export type FilterOffsetType = {
  userOffset: number;
  managerOffset: number;
  branchOffset: number;
};

export type FilterMultiSelectDataType = {
  filterStartDate?: string;
  filterEndDate?: string;
  location: { label: string; value: string };
  manager: { label: string; value: number | null };
  user: { label: string; value: number | null };
  status: { label: string; value: string };
};

type getAllClientPayload = {
  token: string;
  offset: number;
  limit: number;
  searchValue: string | undefined;
};
const AllUsersCheckInsReports = ({
  token,
  fetching,
  success,
  error,
  history,
  message,
  statusCode,
  loginData,
  dispatchResetSession,
  dispatchGetCheckInScheduleList,
  dispatchResetCheckInScheduleList,
  checkInScheduleTotalCount,
  checkInScheduleList,
  finacUsersList,
  finacManagerList,
  totalUserCount,
  userFetching,
  singleCheckInScheduleFetching,
  dispatchGetAllFinacUsersAction,
  dispatchResetMySpaceSuccess,
  dispatchResetMySpaceMessage,
  dispatchResetMySpaceError,
  singleCheckInScheduleDetails,
  dispatchGetSingleCheckInScheduleDetailsAction,
  dispatchResetSingleCheckInScheduleDetails,
  dispatchResetMasterDataListing,
  dispatchGetMasterDataBranch,
  masterDataListing,
  masterDataBranchListTotal,
  dispatchResetFinacManagerList,
  dispatchResetFinacUsersList,
  totalManagerCount,
  dispatchGetAllFinacManagerAction,
}: AppProps) => {
  const { start, end } = getCurrentMonthDates();
  const [offset, setOffset] = useState<number>(0);
  const [checkInOffset, setCheckInOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [showData, setShowData] = useState(false);
  const [userSelected, setUserSelected] = useState<any>({
    value: null,
    label: "Select User",
  });
  const [finalUserList, setFinalUserList] = useState<DropDownItemType[] | []>(
    []
  );
  const [finalManagerListData, setFinalManagerListData] = useState<
    DropDownItemType[] | []
  >([]);
  const [data, setData] = useState<any[]>([]);
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [isCheckInDownloadReportsPresent, setIsCheckInDownloadReportsPresent] =
    useMenuCheck("");
  const [showTeamDetails, setShowTeamDetails] = useState<boolean>(false);
  const [filterToggle, setFilterToggle] = useState<boolean>(false);
  const [filterStartDate, setFilterStartDate] = useState<string>("");
  const [filterEndDate, setFilterEndDate] = useState<string>("");
  const [branchFinalData, setBranchFinalData] = useState<
    DropDownItemType[] | []
  >([]);
  const [filterOffset, setFilterOffset] = useState<FilterOffsetType>({
    userOffset: 0,
    managerOffset: 0,
    branchOffset: 0,
  });
  const [filterText, setFilterText] = useState<FilterTextType>({
    userText: "",
    managerText: "",
    branchText: "",
  });
  const [multiSelectData, setMultiSelectData] =
    useState<FilterMultiSelectDataType>({
      filterStartDate: "",
      filterEndDate: "",
      location: { label: "", value: "" },
      manager: { label: "", value: null },
      user: { label: "", value: null },
      status: { label: "", value: "" },
    });

  const [filterValue, setFilterValue] = useState<FilterMultiSelectDataType>({
    location: { label: "", value: "" },
    manager: { label: "", value: null },
    user: { label: "", value: null },
    status: { label: "", value: "" },
  });

  const [employmentStatusFilterValue, setEmploymentStatusFilterValue] =
    useState<{
      value: null | string;
      label: string;
    }>({
      value: null,
      label: "Select",
    });

  useEffect(() => {
    setIsCheckInDownloadReportsPresent(
      "All Users' Check-Ins Schedule Reports Download",
      "menu"
    );
    dispatchResetMySpaceSuccess();
    dispatchResetMySpaceMessage();
    dispatchResetMySpaceError();
    dispatchResetCheckInScheduleList();
    dispatchResetSingleCheckInScheduleDetails();
    dispatchResetFinacManagerList();
    dispatchResetFinacUsersList();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        search_term: filterText?.userText,
        user_type: "stco_users",
        limit,
        offset: filterOffset?.userOffset,
        status: "1",
      };

      if (+finacUsersList?.total_count) {
        if (+finacUsersList?.total_count > filterOffset?.userOffset) {
          dispatchGetAllFinacUsersAction(finalData);
        }
      } else {
        dispatchGetAllFinacUsersAction(finalData);
      }
    }
  }, [filterOffset?.userOffset]);

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        search_term: filterText?.managerText,
        offset: filterOffset?.managerOffset,
        user_type: "manager",
        limit,
        status: "1",
      };

      if (+totalManagerCount) {
        if (+totalManagerCount > filterOffset?.managerOffset) {
          dispatchGetAllFinacManagerAction(finalData);
        }
      } else {
        dispatchGetAllFinacManagerAction(finalData);
      }
    }
  }, [filterOffset?.managerOffset]);

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        userId: filterValue?.user?.value ? filterValue?.user?.value : null,
        offset: checkInOffset,
        limit,
        role: "hr",
        startDate: filterStartDate,
        endDate: filterEndDate,
        filterManager: filterValue?.manager?.value,
        location: filterValue?.location?.value
          ? filterValue?.location?.label
          : "",
        employmentStatus: filterValue?.status?.value
          ? filterValue?.status?.label
          : "",
      };
      if (checkInScheduleTotalCount) {
        if (checkInScheduleTotalCount > checkInOffset) {
          dispatchGetCheckInScheduleList(finalData);
        }
      } else {
        dispatchGetCheckInScheduleList(finalData);
      }
    }
  }, [checkInOffset]);

  // Branch

  useEffect(() => {
    const finalBranchData = masterDataListing?.map((user: any) => {
      return {
        value: user?._id,
        label: user?.branch_name,
      };
    });
    if (filterOffset?.branchOffset > 0 && masterDataListing?.length) {
      setBranchFinalData([...branchFinalData, ...finalBranchData]);
    } else {
      setBranchFinalData(finalBranchData);
    }
  }, [masterDataListing]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: filterOffset?.branchOffset,
        limit: limit,
        search_term: filterText?.branchText,
      };
      if (filterOffset?.branchOffset <= +masterDataBranchListTotal) {
        dispatchGetMasterDataBranch(finalUserData);
      }
    }
  }, [filterOffset?.branchOffset]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [checkInScheduleList]);

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      if (
        checkInOffset < +checkInScheduleTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (checkInScheduleList?.length > 0) {
          if (!fetching && checkInOffset < +checkInScheduleTotalCount) {
            setCheckInOffset(checkInOffset + limit);
          }
        }
      }
    }
  };

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset: filterOffset?.userOffset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: filterText?.userText,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  const fetchNewBranchData = (search: string) => {
    if (token) {
      let finalUserData = {
        token,
        offset: filterOffset?.branchOffset,
        limit: limit,
        search_term: filterText?.branchText,
      };
      dispatchGetMasterDataBranch(finalUserData);
    }
  };

  const fetchManagerNewData = (search: string) => {
    const finalData = {
      token,
      offset: filterOffset?.managerOffset,
      limit,
      user_type: "manager",
      status: 1,
      search_term: filterText?.managerText,
    };
    dispatchGetAllFinacManagerAction(finalData);
  };

  useDebounce(
    () => {
      if (filterText?.userText) {
        fetchNewData(filterText?.userText);
      } else {
        const finalData = {
          token,
          offset: filterOffset?.userOffset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: "",
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [filterText?.userText]
  );
  useDebounce(
    () => {
      if (filterText?.branchText) {
        fetchNewBranchData(filterText?.branchText);
      } else {
        let finalUserData = {
          token,
          offset: filterOffset?.branchOffset,
          limit: limit,
          search_term: "",
        };
        dispatchGetMasterDataBranch(finalUserData);
      }
    },
    500,
    [filterText?.branchText]
  );

  useDebounce(
    () => {
      if (filterText?.managerText) {
        fetchManagerNewData(filterText?.managerText);
      } else {
        const finalData = {
          token,
          offset: filterOffset?.managerOffset,
          limit,
          user_type: "manager",
          status: 1,
          search_term: "",
        };
        dispatchGetAllFinacManagerAction(finalData);
      }
    },
    500,
    [filterText?.managerText]
  );

  useEffect(() => {
    if (finacUsersList?.data?.length > 0) {
      if (filterOffset?.userOffset <= +finacUsersList?.total_count) {
        let finalUserData = finacUsersList?.data?.map((user: any) => {
          return {
            value: user.user_id,
            label: `${user.first_name} ${user.last_name}`,
            image: user?.profile_pic?.file_url,
          };
        });
        if (filterOffset?.userOffset > 0) {
          setFinalUserList([...finalUserList, ...finalUserData]);
        } else {
          setFinalUserList([...finalUserData]);
        }
      }
    }
  }, [finacUsersList?.data]);

  useEffect(() => {
    if (finacManagerList?.length > 0) {
      if (filterOffset?.managerOffset <= +totalManagerCount) {
        let finalUserData = finacManagerList?.map((user: any) => {
          return {
            value: user.user_id,
            label: `${user.first_name} ${user.last_name}`,
            image: user?.profile_pic?.file_url,
          };
        });
        if (filterOffset?.managerOffset > 0) {
          setFinalManagerListData([...finalManagerListData, ...finalUserData]);
        } else {
          setFinalManagerListData([...finalUserData]);
        }
      }
    }
  }, [finacManagerList]);

  useEffect(() => {
    if (checkInScheduleList?.length === 0) {
      setData(checkInScheduleList);
    } else if (checkInOffset > 0 && checkInScheduleList?.length > 0) {
      setData((prv: any) => [...prv, ...checkInScheduleList]);
    } else {
      setData(checkInScheduleList);
    }
  }, [checkInScheduleList]);

  const handleUserChange = (client: any) => {
    setUserSelected(client);
  };

  const handlePrepareReportData = () => {
    if (token && startDate && endDate) {
      let params: GetCheckInScheduleListPayloadType = {
        token,
        userId: filterValue?.user?.value ? filterValue?.user?.value : null,
        role: "hr",
        startDate: moment(
          startDate,
          "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (zz)"
        ).format("DD-MM-YYYY"),
        endDate: moment(
          endDate,
          "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (zz)"
        ).format("DD-MM-YYYY"),
        filterManager: filterValue?.manager?.value,
        location: filterValue?.location?.value
          ? filterValue?.location?.label
          : "",
        employmentStatus: filterValue?.status?.value
          ? filterValue?.status?.label
          : "",
      };

      handleDownloadReport(params);
    }
  };

  const handleDownloadReport = (params: any) => {
    let reportName = `Check_Ins_Report_${params?.startDate}_to_${params?.endDate}.xlsx`;

    downloadCheckInsReportsApi(params).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };

  const handleViewUsersDetails = (data: any) => {
    dispatchResetSingleCheckInScheduleDetails();
    if (data && token) {
      const finalData = {
        token,
        checkInId: data,
      };
      dispatchGetSingleCheckInScheduleDetailsAction(finalData);
    }
    setShowTeamDetails(true);
  };

  const toggleTeamDetails = () => {
    setShowTeamDetails(false);
  };

  const handleApplyFilter = () => {
    dispatchResetCheckInScheduleList();
    setData([]);
    setCheckInOffset(0);
    setMultiSelectData({
      filterStartDate,
      filterEndDate,
      location: filterValue?.location,
      status: filterValue?.status,
      manager: filterValue?.manager,
      user: filterValue?.user,
    });

    if (token) {
      let finalData = {
        token,
        userId: filterValue?.user?.value ? filterValue?.user?.value : null,
        offset: 0,
        limit,
        role: "hr",
        startDate: filterStartDate,
        endDate: filterEndDate,
        filterManager: filterValue?.manager?.value,
        location: filterValue?.location?.value
          ? filterValue?.location?.label
          : "",
        employmentStatus: filterValue?.status?.value
          ? filterValue?.status?.label
          : "",
      };
      dispatchGetCheckInScheduleList(finalData);
    }
  };

  const handleFilterClear = () => {
    dispatchResetCheckInScheduleList();
    setFilterValue({
      location: { label: "", value: "" },
      manager: { label: "", value: null },
      user: { label: "", value: null },
      status: { label: "", value: "" },
    });

    setMultiSelectData({
      filterStartDate: "",
      filterEndDate: "",
      location: { label: "", value: "" },
      manager: { label: "", value: null },
      user: { label: "", value: null },
      status: { label: "", value: "" },
    });

    if (token) {
      let finalData = {
        token,
        offset: 0,
        limit,
        role: "hr",
      };
      dispatchGetCheckInScheduleList(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetMySpaceSuccess();
              dispatchResetMySpaceMessage();
              dispatchResetMySpaceError();
            }}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMySpaceSuccess();
              dispatchResetMySpaceMessage();
              dispatchResetMySpaceError();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <CommonHeader title="All User's Check-Ins Report" />
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header pb-3">
            <div className="left-header">
              <div className="heading">All User's Check-Ins Report List</div>
              {!fetching && checkInScheduleTotalCount > 0 && (
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  checkInScheduleTotalCount ? checkInScheduleTotalCount : 0
                } check-in schedule found`}</div>
              )}
            </div>
            <div className="right-header">
              {isCheckInDownloadReportsPresent && (
                <div className="mr-2">
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 250 }}
                    overlay={
                      <Tooltip id="button-view-download-invoice">
                        Download Reports
                      </Tooltip>
                    }
                  >
                    <DownloadCheckInReports
                      startDate={startDate}
                      endDate={endDate}
                      setStartDate={setStartDate}
                      setEndDate={setEndDate}
                      handleDownload={handlePrepareReportData}
                    />
                  </OverlayTrigger>
                </div>
              )}
              <div className="mr-1">
                <CheckInsFilter
                  setToggle={setFilterToggle}
                  toggle={filterToggle}
                  fetching={fetching}
                  filterValue={filterValue}
                  setFilterValue={setFilterValue}
                  setFilterStartDate={setFilterStartDate}
                  setFilterEndDate={setFilterEndDate}
                  filterStartDate={filterStartDate}
                  filterEndDate={filterEndDate}
                  branchFinalData={branchFinalData}
                  multiSelectData={multiSelectData}
                  limit={limit}
                  handleApplyFilter={handleApplyFilter}
                  handleFilterClear={handleFilterClear}
                  finalUserList={finalUserList}
                  userSelected={userSelected}
                  handleUserChange={handleUserChange}
                  setFilterText={setFilterText}
                  filterText={filterText}
                  setUserOffset={setOffset}
                  setEmploymentStatusFilterValue={
                    setEmploymentStatusFilterValue
                  }
                  employmentStatusFilterValue={employmentStatusFilterValue}
                  finalManagerListData={finalManagerListData}
                  filterOffset={filterOffset}
                  setFilterOffset={setFilterOffset}
                />
              </div>
            </div>
          </div>
          {fetching && checkInOffset === 0 ? (
            <TableLoader Rows={10} ColumnPerRow={6} />
          ) : checkInScheduleList?.length ? (
            <CheckInScheduleTable
              tableHeader={CHECK_IN_SCHEDULE_HEADERS?.filter(
                (header: TableHeadersType) => header?.value !== "action"
              )}
              data={data}
              handleViewUsersDetails={handleViewUsersDetails}
              type={"hrms"}
              fetching={fetching}
            />
          ) : (
            !fetching && (
              <div className="p-5 mt-3">
                <EmptyListPage title="No List Found!" imageWidth="30%" />
              </div>
            )
          )}
          {fetching && checkInOffset > 0 && <div>{<InfiniteLoader />}</div>}
        </div>
      </div>

      {showTeamDetails && (
        <ViewUsersDetails
          isRight={true}
          isOpen={showTeamDetails}
          onClose={toggleTeamDetails}
          singleCheckInScheduleDetails={singleCheckInScheduleDetails}
          fetching={singleCheckInScheduleFetching}
        />
      )}
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.mySpace.checkInScheduleFetching,
  singleCheckInScheduleFetching: state.mySpace.singleCheckInScheduleFetching,
  message: state.mySpace.message,
  success: state.mySpace.success,
  statusCode: state.mySpace.statusCode,
  error: state.mySpace.error,
  checkInScheduleList: state.mySpace.checkInScheduleList,
  checkInScheduleTotalCount: state.mySpace.checkInScheduleTotalCount,
  loginData: state.auth.loginData,
  userFetching: state.auth.fetching,
  finacUsersList: state.auth.finacUsersList,
  finacManagerList: state.auth.finacManagerList,
  singleCheckInScheduleDetails: state.mySpace.singleCheckInScheduleDetails,
  masterDataListing: state.masterData.masterDataListing,
  masterDataBranchListTotal: state.masterData.masterDataBranchListTotal,
  totalManagerCount: state.auth.totalManagerCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetCheckInScheduleList: (data: GetCheckInScheduleListPayloadType) =>
    dispatch(getCheckInScheduleListAction(data)),
  dispatchResetMySpaceSuccess: () => dispatch(resetMySpaceSuccess()),
  dispatchResetMySpaceMessage: () => dispatch(resetMySpaceMessage()),
  dispatchResetMySpaceError: () => dispatch(resetMySpaceError()),
  dispatchResetCheckInScheduleList: () => dispatch(resetCheckInScheduleList()),
  dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchResetFinacManagerList: () => dispatch(resetFinacManagerList()),
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacManagerAction(data)),
  dispatchGetSingleCheckInScheduleDetailsAction: (
    data: GetSingleCheckInScheduleDetailsPayloadType
  ) => dispatch(getSingleCheckInScheduleDetailsAction(data)),
  dispatchResetSingleCheckInScheduleDetails: () =>
    dispatch(resetSingleCheckInScheduleDetails()),
  dispatchResetMasterDataListing: () => dispatch(resetMasterDataLisitng()),
  dispatchGetMasterDataBranch: (data: GetAllMasterDataBranchPayloadType) => {
    dispatch(getAllMasterDataBranchAction(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllUsersCheckInsReports);
